import React, { useState } from "react";

import { Dialog } from "primereact/dialog";
import { Ripple } from "primereact/ripple";
import { Link } from "react-router-dom";
import { Image } from "primereact/image";
import DocumentViewModal from "../../Components/DocumentViewModal";
import ViewDataGroup from "../../Components/DataViewModal/ViewDataGroup";
import FileActionLoader from "../../Components/FileActionLoader";
import { getAppCurrencyType } from "../../Utils/Common";

import { FSLightData } from "../../Controllers/Types/FinishingSchedule/Light/Light";
import { FSDoorData } from "../../Controllers/Types/FinishingSchedule/Door/Door";
import { FSPaintData } from "../../Controllers/Types/FinishingSchedule/Paint/Paint";
import { FSBathroomData } from "../../Controllers/Types/FinishingSchedule/Bathroom/Bathroom";
import { FSKitchenData } from "../../Controllers/Types/FinishingSchedule/Kitchen/Kitchen";
import { FSTileData } from "../../Controllers/Types/FinishingSchedule/Tile/Tile";
import { FSFloorFinishingData } from "../../Controllers/Types/FinishingSchedule/FloorFinishing/FloorFinishing";
import { FSOtherData } from "../../Controllers/Types/FinishingSchedule/Other/Other";
import { FSAccessoryData } from "../../Controllers/Types/FinishingSchedule/Accessory/AccessoryData";
import { FSDataOrder } from "../../Controllers/Types/FinishingSchedule/Order";
import { FSColor } from "../../Controllers/Types/FinishingSchedule/Color";
import { FSFileList } from "../../Controllers/Types/FinishingSchedule/FileList";

interface FeatureDataViewModalProps {
    isOpen: boolean;
    onClose: () => void;
    feature:
    | 'Light'
    | 'Door'
    | 'Paint'
    | 'Bathroom'
    | 'Kitchen'
    | 'Tiles'
    | 'Floor Finishing'
    | 'Others';

    lightData: FSLightData | null;
    doorData: FSDoorData | null;
    paintData: FSPaintData | null;
    bathroomData: FSBathroomData | null;
    kitchenData: FSKitchenData | null;
    kitchenApplianceData: FSKitchenData | null;
    tileData: FSTileData | null;
    floorFinishingData: FSFloorFinishingData | null;
    otherData: FSOtherData | null;
    accessoryData: FSAccessoryData | null;

    canDelete: boolean;
    fileDeleteLoadingIndex: number | null;
    onDeleteFile: (fileIndex: number, fileDataId: number, isAccessoryFile: boolean) => void;
}


const FeatureDataViewModal: React.FC<FeatureDataViewModalProps> = ({
    isOpen,
    onClose,
    feature,
    lightData,
    doorData,
    paintData,
    bathroomData,
    kitchenData,
    kitchenApplianceData,
    tileData,
    floorFinishingData,
    otherData,
    accessoryData,
    canDelete,
    fileDeleteLoadingIndex,
    onDeleteFile
}) => {
    const [selectedFilePath, setSelectedFilePath] = useState<string>('');
    const [showFileViewModal, setShowFileViewModal] = useState<boolean>(false);
    const currencySymbol = getAppCurrencyType();
    const vatPercentage = Number(localStorage.getItem('vat_percentage') || 0);

    const fsDataViewModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {feature}&nbsp;details
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={onClose}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    )

    const handleViewFile = (filePath: string) => {
        if (filePath && filePath !== "") {
            setShowFileViewModal(true);
            setSelectedFilePath(filePath);
        } else {
            setSelectedFilePath("");
        }
    };

    const handleCloseFileViewModal = () => {
        setShowFileViewModal(false);
        setSelectedFilePath('');
    }

    const orderDataBody = (orderData: FSDataOrder) => {
        return (
            <div className="col-12">
                <h4 className="view_data_head">
                    <i className="bi bi-box me-2"></i>
                    Order details
                </h4>

                <article className="data_view_area">
                    <div className="view_data_group">
                        <div className="row">
                            <div className="col-6 col-sm-5 my-auto">
                                <h5 className="view_data_title">Status :</h5>
                            </div>
                            <div className="col-6 col-sm-7">
                                <span className={`order_status_label
                                    ${orderData?.status === 'Pending' ? 'danger' :
                                        orderData?.status === 'Ordered' ? 'warning' :
                                            orderData?.status === 'Instore' ? 'success' :
                                                'info'
                                    }`}>
                                    {orderData?.status}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="view_data_group">
                        <div className="row">
                            <div className="col-6 col-sm-5">
                                <h5 className="view_data_title">Date :</h5>
                            </div>
                            <div className="col-6 col-sm-7">
                                <h5 className="view_data_content text-capitalize">
                                    {orderData?.date || '---'}

                                    {orderData?.status === 'Ordered' && (
                                        <small className="text_secondary">
                                            ({orderData?.lead_time_week ? `${orderData?.lead_time_week} Weeks` : ''}
                                            {orderData?.lead_time_day ? ` ${orderData?.lead_time_day} Days` : ''})
                                        </small>
                                    )}
                                </h5>
                            </div>
                        </div>
                    </div>

                    <div className="view_data_group">
                        <div className="row">
                            <div className="col-6 col-sm-5">
                                <h5 className="view_data_title">Amount :</h5>
                            </div>
                            <div className="col-6 col-sm-7">
                                {orderData?.is_price_include === 1 ? (
                                    <span className="view_data_content text_secondary">
                                        (Price Included)
                                    </span>
                                ) : (
                                    <h5 className="view_data_content text-capitalize">
                                        {currencySymbol}&nbsp;{orderData ? (orderData?.price || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
                                        <small className="text_secondary">
                                            {orderData?.is_include_vat === 1 ? `(Inc. ${vatPercentage}% VAT)` : ''}
                                        </small>
                                    </h5>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="view_data_group">
                        <div className="row">
                            <div className="col-6 col-sm-5">
                                <h5 className="view_data_title">Note :</h5>
                            </div>
                            <div className="col-6 col-sm-7">
                                <h5 className="view_data_content first_letter_capitalized">
                                    {orderData?.note || '---'}
                                </h5>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        )
    }

    const colorDataBody = (colorData: FSColor | null) => {
        return (
            <div className="view_data_group">
                <div className="row">
                    <div className="col-6 col-sm-5 my-auto">
                        <h5 className="view_data_title">Color :</h5>
                    </div>
                    <div className="col-6 col-sm-7">
                        <h5 className="view_data_content text-capitalize">
                            {colorData ? (
                                <React.Fragment>
                                    <span className="color_label" style={{ backgroundColor: colorData?.color_code || '#FFF' }} />
                                    <span>{colorData?.color_name || '---'}</span>
                                </React.Fragment>
                            ) : '---'}
                        </h5>
                    </div>
                </div>
            </div>
        )
    }

    const imageDataBody = (imageData: string | null) => {
        return (
            <div className="view_data_group">
                <div className="row">
                    <div className="col-6 col-sm-5 my-auto">
                        <h5 className="view_data_title">Image :</h5>
                    </div>
                    <div className="col-6 col-sm-7">
                        {imageData && imageData !== null ? (
                            <div className="files_list_area">
                                <div className="note_image_container response_image_container">
                                    <React.Fragment>
                                        <Image
                                            src={imageData!}
                                            alt={`${feature}_image`}
                                            className="note_img response_image"
                                            preview
                                        />
                                    </React.Fragment>
                                </div>
                            </div>
                        ) : (
                            <h5 className="view_data_content">---</h5>
                        )}
                    </div>
                </div>
            </div>
        )
    }

    const filesDataBody = (dataId: number, filesData: FSFileList[], isAccessory: boolean) => {
        return (
            <div className="view_data_group">
                <div className="row">
                    <div className="col-6 col-sm-5 my-auto">
                        <h5 className="view_data_title">Files :</h5>
                    </div>
                    <div className="col-6 col-sm-7">
                        {filesData && filesData?.length > 0 ? (
                            <div className="files_list_area">
                                {filesData?.map((file) => (
                                    <div className="note_image_container response_image_container" key={`${feature}_${file?.index}`}>
                                        {fileDeleteLoadingIndex === file?.index ? (
                                            <FileActionLoader />
                                        ) : (
                                            <React.Fragment>
                                                {file?.extension === "pdf" ? (
                                                    <div
                                                        className="response_doc_file_container"
                                                        onClick={() => handleViewFile(file?.file_path!)}
                                                    >
                                                        <i className="bi bi-file-earmark-pdf"></i>
                                                    </div>
                                                ) : (
                                                    <Image
                                                        src={file?.file_path!}
                                                        alt={`${file.index + 1}`}
                                                        className="note_img response_image"
                                                        preview
                                                    />
                                                )}
                                            </React.Fragment>
                                        )}

                                        {canDelete && (
                                            <button
                                                className="img_clear_btn p-ripple"
                                                onClick={() => onDeleteFile(file?.index, dataId, isAccessory)}
                                            >
                                                <i className="bi bi-x"></i>
                                            </button>
                                        )}
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <h5 className="view_data_content">---</h5>
                        )}
                    </div>
                </div>
            </div>
        )
    }

    const renderCategorySpecificKitchenData = (data: FSKitchenData) => {
        if (!data?.category) return null;

        const { category, collection, range, color, type, kitchen_style, finish, name, number, size_depth, size_thickness, appliance } = data;

        switch (category) {
            case 'Type':
            case 'Base Units':
            case 'Wall Units':
                return (
                    <>
                        <ViewDataGroup title="Collection" value={collection?.kitchen_collection_name} />
                        <ViewDataGroup title="Range" value={range?.range_name} />
                        {colorDataBody(color)}
                        <ViewDataGroup title="Style" value={kitchen_style?.style_name} />
                        <ViewDataGroup title="Finish" value={finish?.finish_name} />
                    </>
                );

            case 'Worktop':
                return (
                    <>
                        <ViewDataGroup title="Name" value={name} />
                        <ViewDataGroup title="Type" value={type?.type_name} />
                        <ViewDataGroup
                            title="Size"
                            value={`
                                ${size_depth ? `${String(size_depth).padStart(2, '0')} Depth` : '---'}
                                ${size_thickness ? `${String(size_thickness).padStart(2, '0')} Thickness` : '---'}
                            `}
                        />
                    </>
                );

            case 'Door':
                return (
                    <>
                        <ViewDataGroup title="Name" value={name} />
                        <ViewDataGroup title="Style" value={kitchen_style?.style_name} />
                        {colorDataBody(color)}
                    </>
                );

            case 'Handle':
                return (
                    <>
                        <ViewDataGroup title="Name" value={name} />
                        <ViewDataGroup title="Number" value={String(number).padStart(2, '0')} />
                    </>
                );

            case 'Appliance':
                return (
                    <>
                        <ViewDataGroup title="Appliance" value={appliance?.appliance_name} />
                        <ViewDataGroup title="Name" value={name} />
                        {colorDataBody(color)}
                    </>
                );

            default:
                return null;
        }
    };

    const accessoryDataBody = (accessoryDetail: FSAccessoryData) => {
        return (
            <div className="row">
                <div className={`col-12 ${accessoryDetail?.order_data ? 'mb-3' : ''}`}>
                    <h4 className="view_data_head">
                        <i className="bi bi-card-list me-2"></i>
                        {feature}&nbsp;accessory details
                    </h4>

                    <article className="data_view_area">
                        <ViewDataGroup title="Accessory" value={accessoryDetail?.accessory?.accessory_name} />
                        <ViewDataGroup title="Sub accessory" value={accessoryDetail?.accessory_sub?.accessory_sub_name} />
                        <ViewDataGroup title="Number" value={String(accessoryDetail?.number).padStart(2, '0')} />
                        <ViewDataGroup title="Reference" value={accessoryDetail?.reference} isValueTextCapitalized={false} />
                        <ViewDataGroup title="Link" value={accessoryDetail?.link} isLink />
                        {imageDataBody(accessoryDetail?.image_path)}
                        {filesDataBody(accessoryDetail?.id, accessoryDetail?.file_list, true)}
                    </article>
                </div>

                {accessoryDetail?.order_data && (
                    orderDataBody(accessoryDetail?.order_data)
                )}
            </div>
        )
    }

    return (
        <React.Fragment>
            <Dialog
                visible={isOpen}
                headerClassName="custom_modal_header"
                header={fsDataViewModalHeader}
                dismissableMask
                closeOnEscape={false}
                className="custom_modal_dialog modal_dialog_md"
                onHide={onClose}>
                <div className="custom_modal_body">
                    <div className="p-1">
                        {(() => {
                            const renderMap: Record<string, React.ReactNode> = {
                                'Light':
                                    lightData !== null && (
                                        <div className="row">
                                            <div className={`col-12 ${lightData?.order_data ? 'mb-3' : ''}`}>
                                                <h4 className="view_data_head">
                                                    <i className="bi bi-card-list me-2"></i>
                                                    {feature}&nbsp;details
                                                </h4>

                                                <article className="data_view_area">
                                                    <ViewDataGroup title="Item" value={lightData?.item?.item_name} />
                                                    <ViewDataGroup title="Type" value={lightData?.type?.type_name} />
                                                    <ViewDataGroup title="Number" value={String(lightData?.number).padStart(2, '0')} />
                                                    <ViewDataGroup title="Link" value={lightData?.link} isLink />
                                                    {imageDataBody(lightData?.image_path)}
                                                    {filesDataBody(lightData?.id, lightData?.file_list, false)}
                                                </article>
                                            </div>

                                            {lightData?.order_data && (
                                                orderDataBody(lightData?.order_data)
                                            )}
                                        </div>
                                    ),

                                'Door':
                                    doorData !== null ? (
                                        <div className="row">
                                            <div className={`col-12 ${doorData?.order_data ? 'mb-3' : ''}`}>
                                                <h4 className="view_data_head">
                                                    <i className="bi bi-card-list me-2"></i>
                                                    {feature}&nbsp;details
                                                </h4>

                                                <article className="data_view_area">
                                                    {colorDataBody(doorData?.color)}
                                                    <ViewDataGroup title="Fire resistance rating" value={doorData?.fire_resistance_rating} />
                                                    <ViewDataGroup title="Number" value={String(doorData?.number).padStart(2, '')} />
                                                    <ViewDataGroup title="Size type" value={doorData?.size_type} />

                                                    <ViewDataGroup
                                                        title="Size"
                                                        value={doorData?.size_type === 'Standard size' ? (doorData?.size?.size_name) : (doorData?.manual_size)}
                                                    />

                                                    <ViewDataGroup title="Status" value={doorData?.status} />
                                                    <ViewDataGroup title="Note" value={doorData?.note} isValueTextCapitalized={false} />
                                                    {imageDataBody(doorData?.image_path)}
                                                    {filesDataBody(doorData?.id, doorData?.file_list, false)}
                                                </article>
                                            </div>

                                            {doorData?.order_data && (
                                                orderDataBody(doorData?.order_data)
                                            )}
                                        </div>
                                    ) : accessoryData !== null ? (
                                        accessoryDataBody(accessoryData)
                                    ) : null,

                                'Paint':
                                    paintData !== null ? (
                                        <div className="row">
                                            <div className={`col-12 ${paintData?.order_data ? 'mb-3' : ''}`}>
                                                <h4 className="view_data_head">
                                                    <i className="bi bi-card-list me-2"></i>
                                                    {feature}&nbsp;details
                                                </h4>

                                                <article className="data_view_area">
                                                    <ViewDataGroup title="Type" value={paintData?.type} />
                                                    <ViewDataGroup title="Brand" value={paintData?.brand?.brand_name} />
                                                    {colorDataBody(paintData?.color)}
                                                    <ViewDataGroup title="Location" value={paintData?.location?.location_name} />
                                                    <ViewDataGroup title="Link" value={paintData?.link} isLink />
                                                    {imageDataBody(paintData?.image_path)}
                                                    {filesDataBody(paintData?.id, paintData?.file_list, false)}
                                                </article>
                                            </div>

                                            {paintData?.order_data && (
                                                orderDataBody(paintData?.order_data)
                                            )}
                                        </div>
                                    ) : accessoryData !== null ? (
                                        accessoryDataBody(accessoryData)
                                    ) : null,

                                'Bathroom':
                                    bathroomData !== null && (
                                        <div className="row">
                                            <div className={`col-12 ${bathroomData?.order_data ? 'mb-3' : ''}`}>
                                                <h4 className="view_data_head">
                                                    <i className="bi bi-card-list me-2"></i>
                                                    {feature}&nbsp;details
                                                </h4>

                                                <article className="data_view_area">
                                                    <ViewDataGroup title="Feature" value={bathroomData?.sub_feature?.sub_feature_name} />
                                                    <ViewDataGroup title="Name" value={bathroomData?.name} />
                                                    <ViewDataGroup title="Brand" value={bathroomData?.brand?.brand_name} />
                                                    {colorDataBody(bathroomData?.color)}
                                                    <ViewDataGroup title="Size" value={bathroomData?.size} />
                                                    <ViewDataGroup title="Link" value={bathroomData?.link} isLink />
                                                    {imageDataBody(bathroomData?.image_path)}
                                                    {filesDataBody(bathroomData?.id, bathroomData?.file_list, false)}
                                                </article>
                                            </div>

                                            {bathroomData?.order_data && (
                                                orderDataBody(bathroomData?.order_data)
                                            )}
                                        </div>
                                    ),

                                'Kitchen':
                                    kitchenData !== null ? (
                                        <div className="row">
                                            <div className={`col-12 ${kitchenData?.order_data ? 'mb-3' : ''}`}>
                                                <h4 className="view_data_head">
                                                    <i className="bi bi-card-list me-2"></i>
                                                    {feature}&nbsp;details
                                                </h4>

                                                <article className="data_view_area">
                                                    <ViewDataGroup title="Category" value={kitchenData?.category} />
                                                    <ViewDataGroup title="Brand" value={kitchenData?.brand?.brand_name} />
                                                    {renderCategorySpecificKitchenData(kitchenData)}
                                                    <ViewDataGroup title="Link" value={kitchenData?.link} isLink />
                                                    {imageDataBody(kitchenData?.image_path)}
                                                    {filesDataBody(kitchenData?.id, kitchenData?.file_list, false)}
                                                </article>
                                            </div>

                                            {kitchenData?.order_data && (
                                                orderDataBody(kitchenData?.order_data)
                                            )}
                                        </div>
                                    ) : kitchenApplianceData !== null ? (
                                        <div className="row">
                                            <div className={`col-12 ${kitchenApplianceData?.order_data ? 'mb-3' : ''}`}>
                                                <h4 className="view_data_head">
                                                    <i className="bi bi-card-list me-2"></i>
                                                    {feature}&nbsp;{kitchenApplianceData?.category}&nbsp;details
                                                </h4>

                                                <article className="data_view_area">
                                                    <ViewDataGroup title="Brand" value={kitchenApplianceData?.brand?.brand_name} />
                                                    {renderCategorySpecificKitchenData(kitchenApplianceData)}
                                                    <ViewDataGroup title="Link" value={kitchenApplianceData?.link} isLink />
                                                    {imageDataBody(kitchenApplianceData?.image_path)}
                                                    {filesDataBody(kitchenApplianceData?.id, kitchenApplianceData?.file_list, false)}
                                                </article>
                                            </div>

                                            {kitchenApplianceData?.order_data && (
                                                orderDataBody(kitchenApplianceData?.order_data)
                                            )}
                                        </div>
                                    ) : null,

                                'Tiles':
                                    tileData !== null ? (
                                        <div className="row">
                                            <div className={`col-12 ${tileData?.order_data ? 'mb-3' : ''}`}>
                                                <h4 className="view_data_head">
                                                    <i className="bi bi-card-list me-2"></i>
                                                    {feature}&nbsp;details
                                                </h4>

                                                <article className="data_view_area">
                                                    <ViewDataGroup title="Name" value={tileData?.name} />
                                                    <ViewDataGroup title="Type" value={tileData?.type?.type_name} />
                                                    <ViewDataGroup title="Shop" value={tileData?.shop?.shop_name} />
                                                    <ViewDataGroup title="Quantity" value={String(tileData?.quantity).padStart(2, '0')} />
                                                    {colorDataBody(tileData?.color)}
                                                    <ViewDataGroup title="Size" value={String(tileData?.size).padStart(2, '0')} />
                                                    <ViewDataGroup title="Link" value={tileData?.link} isLink />
                                                    {imageDataBody(tileData?.image_path)}
                                                    {filesDataBody(tileData?.id, tileData?.file_list, false)}
                                                </article>
                                            </div>

                                            {tileData?.order_data && (
                                                orderDataBody(tileData?.order_data)
                                            )}
                                        </div>
                                    ) : accessoryData !== null ? (
                                        accessoryDataBody(accessoryData)
                                    ) : null,

                                'Floor Finishing':
                                    floorFinishingData !== null ? (
                                        <div className="row">
                                            <div className={`col-12 ${floorFinishingData?.order_data ? 'mb-3' : ''}`}>
                                                <h4 className="view_data_head">
                                                    <i className="bi bi-card-list me-2"></i>
                                                    {feature}&nbsp;details
                                                </h4>

                                                <article className="data_view_area">
                                                    <ViewDataGroup title="Location" value={floorFinishingData?.location?.location_name} />
                                                    <ViewDataGroup title="Brand" value={floorFinishingData?.brand?.brand_name} />
                                                    <ViewDataGroup title="Type" value={floorFinishingData?.type?.type_name} />
                                                    <ViewDataGroup title="Name" value={floorFinishingData?.name} />
                                                    <ViewDataGroup title="Note" value={floorFinishingData?.note} isValueTextCapitalized={false} />
                                                    <ViewDataGroup title="Link" value={floorFinishingData?.link} isLink />
                                                    {imageDataBody(floorFinishingData?.image_path)}
                                                    {filesDataBody(floorFinishingData?.id, floorFinishingData?.file_list, false)}
                                                </article>
                                            </div>

                                            {floorFinishingData?.order_data && (
                                                orderDataBody(floorFinishingData?.order_data)
                                            )}
                                        </div>
                                    ) : accessoryData !== null ? (
                                        accessoryDataBody(accessoryData)
                                    ) : null,

                                'Others':
                                    otherData !== null && (
                                        <div className="row">
                                            <div className={`col-12 ${otherData?.order_data ? 'mb-3' : ''}`}>
                                                <h4 className="view_data_head">
                                                    <i className="bi bi-card-list me-2"></i>
                                                    {feature}&nbsp;details
                                                </h4>

                                                <article className="data_view_area">
                                                    <ViewDataGroup title="Flooring Screed" value={otherData?.flooring_screed} />
                                                    <ViewDataGroup title="Brand" value={otherData?.brand?.brand_name} />
                                                    <ViewDataGroup title="Number" value={String(otherData?.number).padStart(2, '0')} />
                                                    <ViewDataGroup title="Link" value={otherData?.link} isLink />
                                                    {imageDataBody(otherData?.image_path)}
                                                    {filesDataBody(otherData?.id, otherData?.file_list, false)}
                                                </article>
                                            </div>

                                            {otherData?.order_data && (
                                                orderDataBody(otherData?.order_data)
                                            )}
                                        </div>
                                    ),
                            };

                            const content = feature ? renderMap[feature] : null;

                            return content || (
                                <div className="no_data_found mt-2 mb-2">
                                    <h6>
                                        <i className="bi bi-exclamation-circle me-2"></i>
                                        No detail found!
                                    </h6>
                                </div>
                            );
                        })()}
                    </div>
                </div>
            </Dialog>

            {/* Document view modal */}
            <DocumentViewModal
                isOpen={showFileViewModal}
                onClose={handleCloseFileViewModal}
                fileUrl={selectedFilePath}
            />
        </React.Fragment>
    )
}

export default FeatureDataViewModal;